module.exports = __webpack_public_path__ + "static/bg3-905dc6b180c1b5fe78d00dc6dcd41e5e.jpg";